import {PatientSettingsScreen} from './PatientSettings';
import {SuperAdminSettings} from './SuperAdminSettings';
import React from 'react';
import {useRole} from '@/hooks';
export const SettingsScreen: React.FC = () => {
  const {isPatient, isSuperAdmin} = useRole();
  if (isPatient) {
    return <PatientSettingsScreen />;
  }
  if (isSuperAdmin) {
    return <SuperAdminSettings />;
  }
  return (
    <div>
      <h1>Settings</h1>
    </div>
  );
};
